// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"408": "c19335558442","5545": "20927b2f494d","6863": "454c9f289029","8357": "dd422574e14d","8481": "0d9b0ffb81b2",}[chunkId] + ".css"
}